var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.pressing ? "activated" : "normal",
      attrs: { "data-namespace": "action-button" },
      on: {
        mousedown: _vm.onMousedown,
        touchstart: _vm.onMousedown,
        mouseup: _vm.onMouseup,
        touchend: _vm.onMouseup,
        mouseout: _vm.onMouseup,
        click: _vm.onClick
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }